import CheckMarkIcon from "@assets/icons/check-mark.svg";
import { useI18n } from "@core/i18n/i18n";
import { useFormatPatients } from "@domain/patient/hooks/use-patients";
import { PendingPatient } from "@domain/patient/patient";
import styled from "@emotion/styled";
import { BackgroundIcon } from "@ui/components/common/background-icon";
import {
	InvitationCodeSharingMethod,
	InvitationSentData,
} from "@ui/pages/home/pending-patient-dialog/components/pending-patient-created";
import { stack } from "@ui/style";
import { colors } from "@ui/style/colors";
import React from "react";
import { CreateTemplateCard } from "@ui/pages/home/pending-patient-dialog/components/create-template-card";

interface InvitationCodeSentProps {
	pendingPatient: PendingPatient;
	isNewlyCreatedPatient: boolean;
	invitationSentData: InvitationSentData;
	onPressRetry?: () => void;
	onCreateNewTemplateRequest: () => void;
}

export const InvitationCodeSent: React.FC<InvitationCodeSentProps> = ({
	pendingPatient: { firstName, lastName },
	invitationSentData,
	isNewlyCreatedPatient,
	onPressRetry,
	onCreateNewTemplateRequest,
}) => {
	const { format } = useI18n();
	const { formatPatientName } = useFormatPatients();

	return (
		<Container>
			<BackgroundIcon iconSvg={CheckMarkIcon} />

			{invitationSentData.sharingMethod === InvitationCodeSharingMethod.PRINT ? (
				<div>
					{format("home.pendingPatientDialog.codeSent.print.message", {
						patientName: formatPatientName({ firstName, lastName }),
					})}
				</div>
			) : (
				<>
					<div>
						{isNewlyCreatedPatient
							? format("home.pendingPatientDialog.codeSent.newPatient.email.message", {
									email: invitationSentData.email,
								})
							: format("home.pendingPatientDialog.codeSent.resendCode.email.message", {
									email: invitationSentData.email,
								})}
					</div>
					<NotReceivedMessage>
						{format("home.pendingPatientDialog.codeSent.notReceived")}
						<RetrySpan onClick={onPressRetry}>{format("home.pendingPatientDialog.codeSent.retryButton")}</RetrySpan>
					</NotReceivedMessage>
				</>
			)}

			<CreateTemplateCard onCreateNewTemplateRequest={onCreateNewTemplateRequest}></CreateTemplateCard>
		</Container>
	);
};

const NotReceivedMessage = styled.div`
	color: ${colors.grey80};
`;

const RetrySpan = styled.span`
	margin-left: 0.5em;
	text-decoration: underline;
	cursor: pointer;
`;

const Container = styled.div`
	margin-top: 8px;
	${stack("L", "center", "center")}
	text-align: center;
`;
